import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'

export const TwProjectCard = tw.div<{
  $hover?: boolean
  $dragged?: boolean
  $disabled?: boolean
}>`
  group
  flex
  flex-col

  w-200
  h-100
  p-16
  rounded-4
  select-none
  ${p =>
    cn(
      !p.$disabled && p.$hover ? 'bg-interactive-l100' : 'bg-grey-l80',
      p.$disabled ? 'pointer-events-none' : 'cursor-pointer',
      p.$dragged && 'opacity-0'
    )}
`
TwProjectCard.displayName = 'TwProjectCard'

export const TwHeader = tw.div`
  flex-none
  w-full
  flex
  flex-row
  justify-between
  items-center
`
TwHeader.displayName = 'TwHeader'

export const TwTitle = tw.div<{
  $alien?: boolean
  $hover?: boolean
}>`
  flex-auto
  max-w-136
  overflow-hidden
  text-14
  leading-4
  text-ellipsis
  text-no-wrap
  text-primary
`
TwTitle.displayName = 'TwTitle'

export const TwTitleInput = tw.input`
  all-unset
  flex-auto
  max-w-136
  overflow-hidden
  text-14
  leading-4
  text-no-wrap
  cursor-text
`

export const TwUsers = tw.div`
  flex-none
  w-fit
  flex
  flex-row
`
TwUsers.displayName = 'TwUsers'
